import React, { useState, useEffect } from "react";
import { Form, Select, InputNumber, Tooltip, Input, Typography, DatePicker } from "antd";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { elvis } from "../../Utils";
import Map2 from "../Map/Map2";
import dayjs from 'dayjs';

const { Option } = Select;
const { Title } = Typography;

const TransportServiceDamageForm = props => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const isEditMode = props.isEditMode || false;
  const [serviceOutageTypes, setServiceOutageTypes] = useState([]);

  const formItemLayout = {
    labelCol: {
      sm: { span: 8 }
    },
    wrapperCol: {
      sm: { span: 16 }
    }
  };

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_API_ENDPOINT + "/transport/enums/service-outages")
      .then(({ data }) => {
        setServiceOutageTypes(data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    if (props.record.damage) {
      form.setFieldsValue({
        lossOfService: props.record.damage.lossOfService,
        affectedUsers: props.record.damage.affectedUsers,
        transportOutage: props.record.damage.transportOutage,
        geometry: props.record.damage.geometry,
        startDate: props.record.damage.startDate ? dayjs(props.record.damage.startDate) : null,
        endDate: props.record.damage.endDate ? dayjs(props.record.damage.endDate) : null,
      });
    }
  }, [props.record.damage, form]);

  const onValuesChange = (changedValues) => {
    form.validateFields(Object.keys(changedValues));
  };

  const onFieldsChange = (changedFields, allFields) => {
    if (!isEditMode) return;
    const fieldsError = form.getFieldsError();
    var valid = fieldsError.every(field => !field.errors || field.errors.length === 0);
    
    const values = form.getFieldsValue();
    const newDamage = { ...props.record };
    newDamage.damage.lossOfService = elvis(values.lossOfService);
    newDamage.damage.startDate = elvis(values.startDate);
    newDamage.damage.endDate = elvis(values.endDate);
    newDamage.damage.affectedUsers = elvis(values.affectedUsers);
    newDamage.damage.transportOutage = elvis(values.transportOutage);
    newDamage.damage.geometry = elvis(values.geometry);
    newDamage.valid = valid;
    props.parentCallback(newDamage);
  };

  return (
    <Form 
      {...formItemLayout} 
      className="details_form"
      form={form}
      onValuesChange={onValuesChange}
      onFieldsChange={onFieldsChange}
      name="transportServiceDamage"
    >
      <Title className="details_form_header"
        title="Damages details"
        subTitle="Network Service"
      />
      <Form.Item label="Start Date" name="startDate">
        <DatePicker disabled={!isEditMode} />
      </Form.Item>
      <Form.Item label="End Date" name="endDate">
        <DatePicker disabled={!isEditMode} />
      </Form.Item>
      <Form.Item label="Loss of service (%)" name="lossOfService">
        <InputNumber disabled={!isEditMode} />
      </Form.Item>
      <Form.Item label="Affected Users" name="affectedUsers">
        <InputNumber disabled={!isEditMode} />
      </Form.Item>
      <Form.Item
        label="Traffic disruption"
        name="transportOutage"
        tooltip="Traffic disruption"
      >
        <Select disabled={!isEditMode}>
          {serviceOutageTypes.map(name => (
            <Option key={name} value={name}>
              {t('transportEnums.serviceOutage.' + name, name)}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item label="Affected Area" name="geometry">
        <Map2 name="affected_area"></Map2>
      </Form.Item>
    </Form>
  );
};

export default TransportServiceDamageForm;